import request from '@/utils/request'

export const getWarningList = (params: any) =>
  request({
    url: '/log/warning/list',
    method: 'get',
    params
  })

export const getHistoryList = (params: any) =>
  request({
    url: 'log/history/list',
    method: 'get',
    params
  })
